// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".app-icon-menu[data-v-8edf707e]{position:relative;text-align:center;margin-bottom:7px}.app-icon-menu__inner[data-v-8edf707e]{width:42px;height:42px;position:relative;display:inline-flex;border-radius:50%}.app-icon-menu__text[data-v-8edf707e]{font-size:12px;line-height:25px;color:#8c8c8c;letter-spacing:-0.1px}.app-icon-menu__event-badge[data-v-8edf707e]{position:absolute;display:inline-block;left:29px;top:-3px;width:14px;height:14px;border-radius:50%;background:#ff7070}", ""]);
// Exports
module.exports = exports;
